export default __webpack_public_path__ + "static/assets/ed148d82ff4b4cf14b7afd869458c1b5.jpg";